export { default as AustraliaFlagIcon } from "./flags/australia_flag.svg?react";
export { default as CanadaFlagIcon } from "./flags/canada_flag.svg?react";
export { default as CzechRepublicFlagIcon } from "./flags/czech_republic_flag.svg?react";
export { default as EuropeanUnionFlagIcon } from "./flags/european_union_flag.svg?react";
export { default as GermanyFlagIcon } from "./flags/germany_flag.svg?react";
export { default as GreatBritainFlagIcon } from "./flags/great_britain_flag.svg?react";
export { default as HongKongFlagIcon } from "./flags/hong_kong_flag.svg?react";
export { default as JapanFlagIcon } from "./flags/japan_flag.svg?react";
export { default as MexicoFlagIcon } from "./flags/mexico_flag.svg?react";
export { default as NewZealandFlagIcon } from "./flags/new_zealand_flag.svg?react";
export { default as NigeriaFlagIcon } from "./flags/nigeria_flag.svg?react";
export { default as NorwayFlagIcon } from "./flags/norway_flag.svg?react";
export { default as PolandFlagIcon } from "./flags/poland_flag.svg?react";
export { default as SingaporeFlagIcon } from "./flags/singapore_flag.svg?react";
export { default as SouthAfricaFlagIcon } from "./flags/south_africa_flag.svg?react";
export { default as SpainFlagIcon } from "./flags/spain_flag.svg?react";
export { default as SwitzerlandFlagIcon } from "./flags/switzerland_flag.svg?react";
export { default as TanzaniaFlagIcon } from "./flags/tanzania_flag.svg?react";
export { default as ThailandFlagIcon } from "./flags/thailand_flag.svg?react";
export { default as TurkeyFlagIcon } from "./flags/turkey_flag.svg?react";
export { default as UgandaFlagIcon } from "./flags/uganda_flag.svg?react";
export { default as UnitedArabEmiratesFlagIcon } from "./flags/united_arab_emirates_flag.svg?react";
export { default as USAFlagIcon } from "./flags/usa_flag.svg?react";
export { default as AlertTriageIcon } from "./images/alert-triage.svg?react";
export { default as AlertTriangleIcon } from "./images/alert-triangle.svg?react";
export { default as AlertTriangleOutlineIcon } from "./images/alert-triangle-outline.svg?react";
export { default as ApplicationStartedIcon } from "./images/application-started.svg?react";
export { default as ApplicationWithClipIcon } from "./images/application-with-clip.svg?react";
export { default as ApprovedNotFundedIcon } from "./images/approved-not-funded.svg?react";
export { default as ArrowDownIcon } from "./images/arrow-down.svg?react";
export { default as ArrowUpIcon } from "./images/arrow-up.svg?react";
export { default as BadgeIcon } from "./images/badge.svg?react";
export { default as BriefcaseIcon } from "./images/briefcase.svg?react";
export { default as CalenderIcon } from "./images/calendar.svg?react";
export { default as ChartLineIcon } from "./images/chart-line.svg?react";
export { default as ChartSquareIcon } from "./images/chart-square.svg?react";
export { default as CheckIcon } from "./images/check.svg?react";
export { default as CheckPaddedIcon } from "./images/check-padded.svg?react";
export { default as CheckCircleIcon } from "./images/check-circle.svg?react";
export { default as CheckCircleFilledIcon } from "./images/check-circle-filled.svg?react";
// Success illustration (gradient + glow), imported verbatim from the design
// project's `assets/illustrations/success.svg`. Rendered at 64px.
export { default as SuccessIllustration } from "./images/illustration-success.svg?react";
export { default as WarningIllustration } from "./images/illustration-warning.svg?react";
export { default as ChevronLeftIcon } from "./images/chevron-left.svg?react";
export { default as ChevronRightIcon } from "./images/chevron-right.svg?react";
export { default as ChevronUpDoubleIcon } from "./images/chevron-up-double.svg?react";
export { default as ClockIcon } from "./images/clock.svg?react";
export { default as ClockBadgeIcon } from "./images/clock-badge.svg?react";
export { default as CoinsHandIcon } from "./images/coins-hand.svg?react";
export { default as CopyIcon } from "./images/copy.svg?react";
export { default as CopyCheckIcon } from "./images/copy-check.svg?react";
export { default as CopyLinkIcon } from "./images/copy-link.svg?react";
export { default as CreditCardIcon } from "./images/credit-card-down.svg?react";
export { default as CrossIcon } from "./images/cross.svg?react";
export { default as CurrencyIcon } from "./images/currency-circle.svg?react";
export { default as DemoIcon } from "./images/demo.svg?react";
export { default as DocumentIcon } from "./images/document.svg?react";
export { default as DocumentWhiteIcon } from "./images/document-white.svg?react";
export { default as DotIcon } from "./images/dot.svg?react";
export { default as DownloadIcon } from "./images/download.svg?react";
export { default as EditIcon } from "./images/edit.svg?react";
export { default as LoadingIcon } from "./images/ellipse.svg?react";
export { default as ErrorIcon } from "./images/error-icon.svg?react";
export { default as FacebookRoudedIcon } from "./images/facebook-rounded.svg?react";
export { default as FilterIcon } from "./images/filter.svg?react";
export { default as FundedNotTradedIcon } from "./images/funded-not-traded.svg?react";
export { default as GiftIcon } from "./images/gift.svg?react";
export { default as GlobeIcon } from "./images/globe.svg?react";
export { default as LockUnlockedIcon } from "./images/lock-unlocked.svg?react";
export { default as AddToAListIcon } from "./images/icon-add-to-a-list.svg?react";
export { default as AddToAListIconPNG } from "./images/add-to-a-list-png.png";
export { default as UserNotFoundIcon } from "./images/user-not-found.svg?react";
export { default as BaseAlertCircleIcon } from "./images/icon-base-alert-circle.svg?react";
export { default as BaseAlertTriangleIcon } from "./images/icon-base-alert-triangle.svg?react";
export { default as BaseArrowDownIcon } from "./images/icon-base-arrow-down.svg?react";
export { default as ArrowRightIcon } from "./images/icon-base-arrow-right.svg?react";
export { default as BaseArchiveIcon } from "./images/icon-base-archive.svg?react";
export { default as BaseCheckIcon } from "./images/icon-base-check.svg?react";
export { default as BaseCheckCircleIcon } from "./images/icon-base-check-circle.svg?react";
export { default as BaseDocumentIcon } from "./images/icon-base-document.svg?react";
export { default as DoubleArrowIcon } from "./images/double-arrow.svg?react";
export { default as BaseHorizontalIcon } from "./images/icon-base-dots-horizontal.svg?react";
export { default as DotsHorizontalIcon } from "./images/icon-dots-horizontal.svg?react";
export { default as DotsVerticalIcon } from "./images/icon-base-dots-vertical.svg?react";
export { default as EyeIcon } from "./images/icon-base-eye.svg?react";
export { default as HelpIcon } from "./images/icon-base-help.svg?react";
export { default as BaseInfoIcon } from "./images/icon-base-information.svg?react";
export { default as PlusIcon } from "./images/icon-base-plus.svg?react";
export { default as ShareExternalIcon } from "./images/icon-base-share-external.svg?react";
export { default as SortIcon } from "./images/icon-base-sort.svg?react";
export { default as WorldIcon } from "./images/icon-base-world.svg?react";
export { default as ErrorIconV2 } from "./images/icon-error.svg?react";
export { default as EmailPendingVerificationIcon } from "./images/icon-email-pending-verification.svg?react";
export { default as EmailPendingVerificationBadgeIcon } from "./images/icon-email-pending-verification-badge.svg?react";
export { default as InfoIcon } from "./images/info.svg?react";
export { default as InformationIcon } from "./images/information.svg?react";
export { default as InstagramRoundedIcon } from "./images/instagram-rounded.svg?react";
export { default as KycClockIcon } from "./images/kyc-clock.svg?react";
export { default as LeftNotch } from "./images/left-notch.svg?react";
export { default as LightBulbIcon } from "./images/light-bulb.svg?react";
export { default as LinkIcon } from "./images/link.svg?react";
export { default as LocationPinIcon } from "./images/location-pin.svg?react";
export { default as MailIcon } from "./images/mail.svg?react";
export { default as LinkedinRoundedIcon } from "./images/linkedin-rounded.svg?react";
export { default as MegaphoneIcon } from "./images/megaphone.svg?react";
export { default as LeaveFeedbackIcon } from "./images/message-text-square.svg?react";
export { default as NoDataIcon } from "./images/no-data.svg?react";
export { default as NoResultsIcon } from "./images/no-results.svg?react";
export { default as ExternalLinkIcon } from "./images/open-link.svg?react";
export { default as PartnersLogoIcon } from "./images/partners-logo.svg?react";
export { default as PartnersLogoDarkIcon } from "./images/partners-logo-dark.svg?react";
export { default as PepperstoneIcon } from "./images/pepperstone.svg?react";
export { default as PinIcon } from "./images/pin.svg?react";
export { default as PepperStoneLogo } from "./images/plectrum.svg?react";
export { default as Profile02 } from "./images/profile-02.svg?react";
export { default as Profile03 } from "./images/profile-03.svg?react";
export { default as QRCodeIcon } from "./images/qr-code.svg?react";
export { default as RightPointer } from "./images/right-pointer.svg?react";
export { default as SearchIcon } from "./images/search.svg?react";
export { default as ShieldIcon } from "./images/shield.svg?react";
export { default as ShieldProtectedIcon } from "./images/shield-protected.svg?react";
export { default as Spinner } from "./images/spinner.svg?react";
export { default as TierBrilliant } from "./images/tier-brilliant.png";
export { default as TierBronze } from "./images/tier-bronze.png";
export { default as TierElite } from "./images/tier-elite.png";
export { default as TierGold } from "./images/tier-gold.png";
export { default as TierPlatinum } from "./images/tier-platinum.png";
export { default as TierSilver } from "./images/tier-silver.png";
export { default as TotalActiveClientsIcon } from "./images/total-active-clients.svg?react";
export { default as TotalClientsIcon } from "./images/total-clients.svg?react";
export { default as TotalEarningsIcon } from "./images/total-earnings.svg?react";
export { default as User02Icon } from "./images/user-02.svg?react";
export { default as UserTickIcon } from "./images/user-tick.svg?react";
export { default as Users2Icon } from "./images/users-2.svg?react";
export { default as UsersArrowIcon } from "./images/users-arrow.svg?react";
export { default as UsersCheck } from "./images/users-check.svg?react";
export { default as XRoundedIcon } from "./images/x-rounded.svg?react";
export { default as YoutubeRoundedIcon } from "./images/youtube-rounded.svg?react";
export { default as ArrowLeftIcon } from "./images/icon-base-arrow-left.svg?react";
export { default as ExpandIcon } from "./images/expand.svg?react";
export { default as MinimizeIcon } from "./images/minimise.svg?react";
export { default as GearIcon } from "./images/gear.svg?react";
export { default as ExportIcon } from "./images/export.svg?react";
export { default as CrossFieldIcon } from "./images/icon-base-cross-field.svg?react";
export { default as CalculatorIcon } from "./images/icon-base-calculator.svg?react";
/**
 * Resolve a PNG import to a usable `<img src>` string across bundlers.
 * Vite returns the asset URL as a string, while Next.js (used by backoffice
 * via `transpilePackages`) returns a `StaticImageData` object `{ src, ... }`.
 * Without this, `<img src={icon}>` renders `[object Object]` under Next.
 */
export const resolveImageSrc = (icon: string | { src: string }): string =>
  typeof icon === "string" ? icon : icon.src;
